// extracted by mini-css-extract-plugin
export var active = "_a9-a";
export var activeIndicator = "_a9-8";
export var animate = "_a9-9";
export var disabled = "_a9-b";
export var fullWidth = "_a9-2";
export var lg = "_a9-7";
export var md = "_a9-6";
export var redoButtonTabGroup = "_a9-0";
export var sm = "_a9-5";
export var tabButton = "_a9-3";
export var tabButtonsContainer = "_a9-1";
export var xs = "_a9-4";